import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter2 extends Component {
  static displayName = Chapter2.name;

  render () {
    return (
      <div>
        <section
        id="jeevan-parichay"
        className="container"
        style={{ marginTop: "60px", marginBottom: "80px" }}
      >
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2
            style={{
              color: "var(--accent)",
              textAlign: "center",
              fontSize: "clamp(26px,3vw,38px)",
              marginBottom: "18px",
            }}
          >
            🌼 अध्याय–2 गुरुदेव की बाल-लीला 🌼
          </h2>

          {/* Intro */}
          <div
            style={{
              display: "flex",
              gap: "24px",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "18px",
            }}
          >
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  margin: "0 auto",
                  border: "4px solid var(--accent)",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
                }}
              >
                <img
                  src="/images/IMG_5427-removebg-preview.png"
                  alt="Swami Brahmanand Saraswati Ji"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                <strong>बाल्यकाल की दिव्य झलक</strong>
                <br />
                पोखवां ग्राम में उस समय एक बालक बढ़ रहा था— शांत स्वरूप,
                किंतु नेत्रों में अद्भुत करुणा और चित्त में दृढ़ता।
                लोग कहते—
                <strong>“यह बच्चा सामान्य नहीं। इसके आसपास अजीब-सा शांत प्रकाश रहता है।”</strong>
                पर किसी को अनुमान न था कि आने वाले समय में यही बालक सत्य की आवाज़ बनकर,
                क्रोध और विद्रोह की ज्वाला को एक क्षण में शांत कर देगा।
              </p>
            </div>
          </div>

          <hr
            style={{
              border: "none",
              height: "1px",
              background: "rgba(255,255,255,0.03)",
              margin: "18px 0 22px",
            }}
          />

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌸 पिताजी तीर्थ यात्रा पर</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गुरुदेव की पूज्या माता जी भावपूर्ण स्वर में कहा करती थीं:
              <strong>
                “उन दिनों गुरुदेव के पिता श्री जगदीश बाबू तीर्थयात्रा हेतु मथुरा धाम पधारे थे।
                यमद्वितीया का समय था— जो बिहार में अत्यंत शुभ और पुण्यदायी माना जाता है।”
              </strong>
              घर में वातावरण शांत था, परंतु दूर कहीं विद्रोह की आँधी उठने लगी थी।
            </p>

            {/* More Sections */}
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌋 किसान आंदोलन की ज्वाला</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              गया ज़िले के टिकारी परगना के मल्डा गाँव के आस-पास
        कई किसान उस समय के वामपंथी प्रभाव में आ रहे थे।
        स्वामी सहजानंद सरस्वती जी की घोषणाओं ने
        उन्हें शोषण के विरुद्ध खड़े होने का साहस दिया था।

        धीरे-धीरे यह आंदोलन जनांदोलन बन गया।

        इस ज्वालामुखी की चिंगारी
        पोखवां के ज़मीदार
        श्री जगदीश नारायण बाबू
        तक पहुंच गई थी।

        और फिर—
        उनकी जमींदारी भी विद्रोह के घेरे में आ गई।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>😟 माता का भय</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              जब यह समाचार पोखवां पहुँचा,
        पूरे घर का वातावरण बदल गया।
        लोग घबराने लगे।
        माता जी के चेहरे पर चिंता की रेखाएँ उभर आईं।

        वह सोचतीं—
        पति दूर मथुरा में!
        यह विद्रोह बढ़ा तो घर, परिवार और गाँव का क्या होगा?

        पर तभी—
        माँ के आँसू पोंछते हुए
        एक किशोर बालक आगे आया।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              🌿 बालक ब्रह्म नारायण का दिव्य विश्वास
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              केवल 12–15 वर्ष की आयु…
        पर चेहरे पर आश्चर्यजनक आत्मविश्वास।

        माता चिंतित थीं,
        और बालक ने विनम्र किंतु दृढ़ स्वर में कहा—

        <strong>“सरकार! घबराइए मत।
        जो लोग विद्रोह पर उतारू हैं,
        आज साँझ तक स्वयं आपके चरणों में गिरकर क्षमा माँगेंगे।”</strong>

        माता ने सोचा—
        “यह बच्चा है, डर गया होगा…
        या शायद मुझे ढांढस बंधा रहा है।”

        उन्होंने बहुत समझाया, रोका,
        लेकिन उसका निश्चय अडिग था।

        वह उठा, पिता की छड़ी हाथ में ली,
        खुले माथे, निर्भीक आँखों से
        अकेले ही घोड़े पर सवार हुआ
        और मल्डा के लिए प्रस्थान कर गया।

        एक माँ देखती रह गई—
        और इतिहास उस क्षण को लिखने लगा।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              ⚡ किशोर की वाणी — शस्त्र बनकर
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              उस समय विद्रोही किसान
        चैता ग्राम के एक निष्ठावान रैयत के घर पर
        आक्रमण की योजना बना रहे थे।

        गाँव का माहौल उथल-पुथल,
        डर, क्रोध और हिंसा से भरा हुआ…

        और उसी भीड़ में
        एक अकेला किशोर पहुँचा।

        कोई घोड़ा रोकने नहीं आया,
        कोई पूछने नहीं आया कि— “तू कौन है?”
        पर जैसे ही उसकी आवाज़ गूँजी—
        भीड़ शांत होने लगी।

        ब्रह्म नारायण ने
        बिना क्रोध, बिना अपमान,
        बहुत शांत और अत्यंत प्रभावशाली तर्क प्रस्तुत किए।

        उसकी वाणी में
        विज्ञान की तार्किकता,
        धर्म की करुणा,
        और सत्य का तेज था।

        सभी किसान निर्निमेष होकर सुनते रहे।

        कुछ क्षणों बाद
        भीड़ शांत—सोच में डूबी—
        और हथियार झुकने लगे।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              🔱 तर्क की शक्ति के आगे नेता भी नतमस्तक
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              किसानों के साथ थे
        महान वामपंथी आंदोलन के युवा नेता,
        स्वामी सहजानंद सरस्वती जी के मुख्य सहयोगी—
        पंडित यदुनंदन शर्मा।

        अत्यंत विद्वान,
        जागरूक, साहसी,
        विद्रोह का नेतृत्व करने वाले।

        पर जब उनकी दृष्टि
        उस किशोर से मिली,
        तो एक क्षण को लगा—
        मानो वह बालक नहीं,
        एक तेजोमय सत्ता खड़ी है।

        उन्होंने चर्चा की—
        विचार, नीति, न्याय, धर्म…
        और कुछ ही मिनटों में
        यह विद्वान नेता
        उस बालक के शब्दों से
        निःशस्त्र हो गया।

        उस क्षण
        भीड़ को लगा कि
        यह बालक शासन नहीं करता—
        यह हृदय जीतता है।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌅 साँझ — भविष्यवाणी की सिद्धि</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              और सचमुच—
        जैसा बालक ने माँ से कहा था,
        वैसा ही हुआ।

        साँझ ढलते-ढलते
        दूर से एक जुलूस दिखाई दिया।

        आगे-आगे
        यदुनंदन शर्मा,
        पीछे-पीछे सैकड़ों किसान…

        सभी हाथ जोड़कर,
        आँखों में पश्चाताप लिए
        पोखवां आए।

        उन्होंने माता जी और जगदीश बाबू के नाम
        क्षमा याचना की।

        और उसी क्षण
        यदुनंदन शर्मा
        बालक के चरणों में झुक गए —
        और बोले—

        <strong>“आज मैंने केवल एक बालक नहीं देखा।
        मैंने धर्म का वह प्रकाश देखा है
        जो एक दिन समाज का पथ-प्रदर्शक बनेगा।”</strong>
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>
              🌺 यह बाल-लीला नहीं—दैवी संकेत था
            </h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              अखाड़े, सेना, हथियार—
        सब जहाँ असफल हो जाते हैं,
        वहाँ सत्य और वाणी
        युद्ध जीते हैं।

        यह घटना
        केवल गाँव, किसान और एक बालक की कहानी नहीं—
        यह उस दैवी शक्ति की घोषणा थी
        जो आने वाले समय में
        धर्म, शांति और वेदांत का सूरज बनकर
        पूरे भारत पर प्रकाश फैलाने वाली थी।

        बालक ब्रह्म नारायण ने सिद्ध कर दिया—<br/>
        ✅ धर्म शक्ति है<br/>
        ✅ वाणी तेज है<br/>
        ✅ और सत्य अजेय है<br/><br/>

        यही बालक आगे चलकर
        गुरुदेव स्वामी ब्रह्मानंद सरस्वती जी महाराज बने।

        और यह—
        उनके जीवन की दैवी लीला का मात्र आरम्भ था…
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter1" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>-
            <Link to="/Chapter3" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
          </div>
        </div>
      </section>

      {/* Events */}
      <section id="events" style={{ padding: "6px 0 28px" }}>
        <div className="container">
          <h3 style={{ color: "var(--accent)", marginBottom: "12px" }}>
            Upcoming Events / Satsangs
          </h3>

          <div className="events fade-up">
            <div className="event">
              <div style={{ fontSize: "12px", color: "var(--muted)" }}>
                Dec 05, 2025 • 6:00 PM
              </div>
              <h4>Evening Satsang & Kirtan</h4>
              <p style={{ margin: "6px 0", color: "rgba(255,235,200,0.9)" }}>
                Join for bhajans, kirtan and satsang with Swami Ji.
              </p>
            </div>

            <div className="event">
              <div style={{ fontSize: "12px", color: "var(--muted)" }}>
                Jan 12, 2026 • 10:00 AM
              </div>
              <h4>Yagna & Blessings</h4>
              <p style={{ margin: "6px 0", color: "rgba(255,235,200,0.9)" }}>
                A special yagna for peace and prosperity.
              </p>
            </div>

            <div className="event">
              <div style={{ fontSize: "12px", color: "var(--muted)" }}>
                Feb 21, 2026 • 5:00 PM
              </div>
              <h4>Spiritual Retreat Day</h4>
              <p style={{ margin: "6px 0", color: "rgba(255,235,200,0.9)" }}>
                Meditation, satsang and community feast.
              </p>
            </div>
          </div>
        </div>
      </section>
      </div>
    );
  }
}